import * as React from 'react';
import { Stack, Text, DefaultButton } from '@fluentui/react';

import { getHeroBannerStyles, heroBannerGradients } from './HeroBanner.styled';

interface HeroBannerAction {
  text: string;
  icon?: string;
  onClick: () => void;
  badge?: number;
}

interface HeroBannerProps {
  title: string;
  subtitle: string;
  actions?: HeroBannerAction[];
  variant?: 'teal' | 'blue' | 'dark';
}

export const HeroBanner: React.FC<HeroBannerProps> = ({ title, subtitle, actions, variant = 'teal' }) => {
  const gradient = heroBannerGradients[variant];
  const styles = getHeroBannerStyles(gradient);

  return (
    <Stack
      horizontal
      verticalAlign="center"
      horizontalAlign="space-between"
      tokens={{ padding: '32px 36px' }}
      className={styles.root}
      wrap
    >
      <Stack>
        <Text className={styles.title}>
          {title}
        </Text>
        <Text className={styles.subtitle}>
          {subtitle}
        </Text>
      </Stack>
      {actions && actions.length > 0 && (
        <Stack horizontal tokens={{ childrenGap: 12 }}>
          {actions.map((action) => (
            <DefaultButton
              key={action.text}
              onClick={action.onClick}
              styles={{
                root: styles.actionButton,
                rootHovered: styles.actionButtonHovered,
              }}
            >
              <Stack horizontal verticalAlign="center" tokens={{ childrenGap: 3 }}>
                {action.icon && <span style={{ fontSize: 18, lineHeight: 1 }}>{action.icon}</span>}
                <span>{action.text}</span>
                {action.badge !== undefined && (
                  <span className={styles.badge}>
                    {action.badge}
                  </span>
                )}
              </Stack>
            </DefaultButton>
          ))}
        </Stack>
      )}
    </Stack>
  );
};
